<template>
  <Modal 
    :id="'cmp-product-alternate-setup-modal'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{$t('alternative_artist_title_release')}}</template>

    <template slot="body">
      <TextField
        :id="'alt_title'"
        class="m1"
        v-bind="textFieldConfig"
        :value="product.alt_title"
        :placeholder="$dft.capHead($t('alt_title'))"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        :id="'alt_artist'"
        class="m1"
        v-bind="textFieldConfig"
        :value="product.alt_artist"
        :placeholder="$dft.capHead($t('alt_artist'))"
        @valuechanged="onTextFieldValueChange"
      />
      <div class="ut-flex">
        <TextField
          :id="'release_shift'"
          class="m1"
          style="flex:1"
          v-bind="textFieldConfig"
          :value="product.release_shift"
          :placeholder="$dft.capHead($t('release_shift'))"
          @valuechanged="onTextFieldValueChange"
        />
      </div>
      <TextField
        :id="'preorder_date'"
        :type="'date'"
        class="m1"
        v-bind="textFieldConfig"
        :value="product.preorder_date"
        :placeholder="$dft.capHead($t('preorder_date'))"
        @valuechanged="onTextFieldValueChange"
      />
      <TextField
        :id="'UUID'"
        :disabled="true"
        class="m1"
        v-bind="textFieldConfig"
        :value="product.UUID"
        :placeholder="$dft.capHead($t('UUID'))"
        @valuechanged="onTextFieldValueChange"
      />
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
        <button class="dt-button v1 s6" @click="onOkClicked">{{$t('ok')}}</button>
        
    
 
      
    </template>

  </Modal>
</template>

<script>



import { Subject } from "rxjs";


import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';
import { ProductsService } from '../../services/products.service';






export default {
  props: {


  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],
  // watch: {
  //   searchString: {
  //     immediate: true,
  //     handler: function(to, from) {
  //       console.log(`searchString Change to ${to} from ${from}`);
  //     }
  //   }
  // },
  data: function() {
    return {

      product:{},
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
    
     

    
    
    };
  },
  mounted:async function() {
    const resData = await ProductsService.fetchProductRelease(this.$route.query.product_id);

    this.product = resData.data.product

    console.log(resData,":::::::::")
  },
  computed: {
  
    product_id: function() {
      return this.$route.query.product_id;
    },

  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      this.product[name] = value;
    },
    onOkClicked:function(){
      //console.log(this.product['licence_name']);
      const  { alt_artist,alt_title,release_shift,product_id,preorder_date }=this.product;

      //console.log(payload)
      this.$emit("update",{ alt_artist,alt_title,release_shift,product_id,preorder_date })
    },

    onCancel: function() {
  
      this.$emit("cancelled", true);
    },

  }
};


</script>

<style lang="scss" scoped>
.cmp-product-alternate-setup-modal{
.dt-modal--body {
  margin-left: 0px;
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
}

</style>